import path from 'path-browserify';

import { getBaseUrl } from '@api/base-url';

const base = (): string => path.join(getBaseUrl({ version: 1 }), 'shares/');

const urls = Object.freeze({
  shares: (): string => path.join(
    base(),
    '',
  ),
});

export default urls;
